import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

export const GlobalStyles = createGlobalStyle`
  ${reset}

  * {
    box-sizing: border-box;
  }

  body {
    font-family: 'NanumSquareNeo', 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 
                'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 
                'Open Sans', 'Helvetica Neue', sans-serif;

    font-size: 16px;
    font-weight: 400;  /* Regular 웨이트 기본값 */

    color: #000;
    background-color: #fff;
    overflow-x: hidden;
    
    /* 폰트 렌더링 최적화 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    
    /* 텍스트 크기 자동 조정 방지 */
    text-size-adjust: none;
    
    /* 터치 관련 설정 */
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-overflow-scrolling: touch;
    
    /* 텍스트 선택 방지 */
    user-select: none;
  }
`;
